import { Editor, type EditorEvent, type Events, type Ui } from 'tinymce';
import { NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import * as FlatModels from '@medsurf/flat-models';
import { MediaControlService } from '@medsurf/flat-services';
import * as BasePlugin from '../base/media.base.plugin.editor';


export const register = (
  editor: Editor,
  zone: NgZone,
  translate: TranslateService,
  dialogService: DialogService,
  mediaControlService: MediaControlService
) => {

  const nodeChangedCallback = (
		buttonApi: Ui.Toolbar.ToolbarToggleButtonInstanceApi,
		event: EditorEvent<Events.NodeChangeEvent>
	) => {
    const element = (<HTMLElement>event.element);
    const isImage = element?.tagName?.toLowerCase() === 'img';

    buttonApi.setEnabled(isImage || editor.selection.getContent() === '');
    buttonApi.setActive(isImage);
  }

  const onSetup = (buttonApi: Ui.Toolbar.ToolbarToggleButtonInstanceApi) => {
    editor.on('NodeChange', (event) => nodeChangedCallback(buttonApi, event));
    return () => {
      editor.off('NodeChange', (event) => nodeChangedCallback(buttonApi, event));
    };
  };

  const onAction = () => {
    const allowedTypes: FlatModels.MediaEntityModels.MediaType[] = [FlatModels.MediaEntityModels.MediaType.enum.MediaImage];

    const node = <HTMLElement>editor.selection.getNode();
    const isImage = node?.tagName?.toLowerCase() === 'img';
    const id = node.dataset['id'];

    const selected: FlatModels.ModalAuthorModels.SelectedMediaDialogItem | undefined =
      isImage && id ? { id, type: FlatModels.MediaEntityModels.MediaType.enum.MediaImage } : undefined;

    try {
      zone.run(async () => {
        editor.editorManager.focusedEditor = null;
        const media = await BasePlugin.openMediaDialog(
          translate.instant("global.image_edit"),
          dialogService,
          allowedTypes,
          selected
        );
        editor.editorManager.focusedEditor = editor;

        if (!media) return;
        const url = mediaControlService.getEditorUrl(media);
        
        if (isImage) {
          editor.dom.setAttribs(node, {
            src: url,
            alt: media.name,
            'data-id': media.id
          });
          editor.dispatch('change');
        } else {
          const element = document.createElement('img');
          element.src = url;
          element.alt = media.name;
          element.dataset['id'] = media.id;
          element.width = 200;
          editor.insertContent(element.outerHTML);
        }
      });
    } catch (err) {
      return;
    }
  }

  editor.ui.registry.addToggleButton('mediaimage', {
    icon: 'image',
    tooltip: 'Insert/edit image',
    onAction,
    onSetup
  });
}